module.exports = __webpack_public_path__ + "static/img/background.5ea89c68.svg";